import { Link } from "react-router-dom";
import { useLanguage } from "../../../utils/languageContext";

const PMNDPSidebar = ({ setIsSidebarVisible }) => {

    const { t } = useLanguage();
    
    const handleClick = () => {
    if (window.innerWidth <= 768) {   // mobile check
      setIsSidebarVisible(false);
    }
  };
    return (
        <>
            <Link className="menu-link" to="/machine-master" onClick={handleClick}>
                <div className="menu-item">
                    <img src={"/images/Sloatmanagement.svg"} className="menu-icon-pmndp" alt="Machine Master" />
                    <span>{t('sidebar.machinemaster')}</span>
                   
                </div>
            </Link>
            <Link className="menu-link" to="/slot-management" onClick={handleClick}>
                <div className="menu-item">
                    <img src={"/images/Sloatmanagement.svg"} className="menu-icon-pmndp" alt="Slot Management" />
                    <span>{t('sidebar.slotManagement')}</span>
                   
                </div>
            </Link>

            <Link className="menu-link" to="/patient-dialysis-list" onClick={handleClick}>
                <div className="menu-item">
                    <img src={"/images/Dilaysismodule.svg"} className="menu-icon-pmndp" alt="Dialysis Module" />
                    <span>{t('sidebar.dialysisModule')}</span>
                    
                </div>
            </Link>
        </>
    )
}

export default PMNDPSidebar;